import { useEffect, useState } from "react";
import { fetchGhlOverview, type GhlOverview } from "@/services/ghl";

export type UseGhlOverviewState = {
  /** Datos reales de GHL, una vez cargados. null mientras carga o si no hay contacto vinculado. */
  data: GhlOverview | null;
  loading: boolean;
  /** true si el usuario autenticado no tiene (todavía) un contacto de GHL asociado a su correo. */
  noContact: boolean;
};

/**
 * Carga una sola vez el resumen de progreso real del usuario desde GHL
 * (racha de hábitos, última clase, progreso por curso). Pensado para
 * usarse en Mi Ruta, Cursos y Perfil, que todos necesitan el mismo
 * overview.
 */
export function useGhlOverview(): UseGhlOverviewState {
  const [state, setState] = useState<UseGhlOverviewState>({
    data: null,
    loading: true,
    noContact: false,
  });

  useEffect(() => {
    let cancelled = false;

    fetchGhlOverview().then((result) => {
      if (cancelled) return;
      if (result.ok) {
        setState({ data: result.data, loading: false, noContact: false });
      } else {
        const reason = "reason" in result ? result.reason : undefined;
        setState({ data: null, loading: false, noContact: reason === "no_contact" });
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
